import { render, staticRenderFns } from "./RentabilidadeGrafico.vue?vue&type=template&id=d60393ac&scoped=true&"
import script from "./RentabilidadeGrafico.vue?vue&type=script&lang=js&"
export * from "./RentabilidadeGrafico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60393ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d60393ac')) {
      api.createRecord('d60393ac', component.options)
    } else {
      api.reload('d60393ac', component.options)
    }
    module.hot.accept("./RentabilidadeGrafico.vue?vue&type=template&id=d60393ac&scoped=true&", function () {
      api.rerender('d60393ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Dashborard/components/RentabilidadeGrafico.vue"
export default component.exports